import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const textEvidenceIcon: IIcon = new Icon(
    `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><path d="M61 0a3 3 0 013 3v58a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h58zM34.772 21.643L17.917 38.496 16 48l9.503-1.917L42.359 29.23l-7.587-7.588zM40.412 16l-3.755 3.756 7.587 7.59L48 23.585 40.412 16z"/></svg>`
);
